/* eslint-disable linebreak-style */
export const StyledTypoName = {
  fontSize: '36px',
  mt: 4,
  mx: '3%',
  color: 'white',
  mb: '20px',

  '@media (min-width: 550px)': {
    mb: '25px'
  },

  '@media (min-width: 750px)': {
    mb: '30px'
  }
};

export const StyledBtnBox = {
  display: 'flex',
  justifyContent: 'space-around'
};

export const StyledBtn = {
  width: '150px',
  mt: '10px',
  mx: '3%',
  mb: '5%',
  backgroundColor: '#446173'
};